// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"tm-z","badgeLink":"um-z","category":"vm-z"};